import React from 'react';

import { FormattedMessage } from 'react-intl';

import { AvatarPropTypes } from '@atlaskit/avatar';
import {
  DeletedUserAvatar,
  DeletedUserName,
  UserAvatar,
  UserName,
} from '@atlassian/bitbucket-user-profile';
import { RelativeDate } from '@atlassian/bitkit-date';

import { User } from 'src/components/types';

import messages from './uploaded-by.i18n';
import * as styles from './uploaded-by.styles';

type Props = {
  dateTime?: string;
  user?: User;
};

const avatarProps: Partial<AvatarPropTypes> = {
  size: 'medium',
};

export default function UploadedBy({ dateTime, user }: Props): JSX.Element {
  return (
    <styles.UploadedBy>
      <styles.AvatarWrapper>
        {user ? (
          <UserAvatar {...avatarProps} user={user} />
        ) : (
          <DeletedUserAvatar {...avatarProps} />
        )}
      </styles.AvatarWrapper>
      <div>
        <FormattedMessage {...messages.uploadedBy} />{' '}
        {user ? <UserName user={user} /> : <DeletedUserName />}{' '}
        {dateTime && <RelativeDate date={dateTime} />}
      </div>
    </styles.UploadedBy>
  );
}
